import { create } from 'zustand';

/**
 * The assistant turns the guest stopped. The AI SDK runtime reports a stopped turn as `complete`,
 * the same as a finished one, so the Stop click is the only record. Per tab and lost on reload.
 */
const useStoppedTurns = create<{ ids: ReadonlySet<string> }>(() => ({ ids: new Set() }));

export function setTurnStopped({ messageId, stopped }: { messageId: string; stopped: boolean }) {
  useStoppedTurns.setState(function withStopChange({ ids }) {
    const next = new Set(ids);
    if (stopped) next.add(messageId);
    else next.delete(messageId);
    return { ids: next };
  });
}

export function isTurnStopped(messageId: string | undefined): boolean {
  return messageId !== undefined && useStoppedTurns.getState().ids.has(messageId);
}

export function useTurnStopped(messageId: string | undefined): boolean {
  return useStoppedTurns(({ ids }) => messageId !== undefined && ids.has(messageId));
}
